import { useMutation, useQueryClient } from "react-query";
import { createApiWithPath } from "../../client";
import { queryKeys } from "../../query";
import { TallyMappingPayload } from "../../types/tally";

const saveMappings = async (payload: TallyMappingPayload): Promise<void> => {
  await createApiWithPath("tally").put("/mapping", payload);
};

export const useTallyMapping = () => {
  const queryClient = useQueryClient();

  return useMutation((payload: TallyMappingPayload) => saveMappings(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.tallyForms());
    },
  });
};
